var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass:
        "d-flex align-items-end form-group-material hide-selection-choice position-relative",
    },
    [
      _c("select2", {
        ref: "select",
        attrs: {
          id: _vm.id,
          data: _vm.tags,
          value: _vm.selectedLabelsIds,
          multiple: "",
          name: _vm.id,
          options: _vm.options,
          "format-data": _vm.formatData,
        },
        on: { change: _vm.handleChange },
      }),
      _vm._v(" "),
      _vm.loading
        ? _c("inline-loader", {
            staticClass: "mx-2",
            attrs: { width: "16px", height: "16px" },
          })
        : _vm._e(),
      _vm._v(" "),
      _vm.loading
        ? _c("div", {
            staticClass: "overlay clear w-100 h-100 rounded-0",
            style: { opacity: "0.7" },
          })
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }